import store from '@/store';
import axios from 'axios'
export abstract class AbstractAdapter {
    public async get(url: string): Promise<any> {
        return await axios.get(url);
    }

    public startLoading(): void {
        store.dispatch('startLoading');
    }

    public finishLoading(): void {
        store.dispatch('finishLoading');
    }
}